import { HandlerWithResult, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain,DispatchSetFilterQuery } from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import setFilterQuery from "@insite/client-framework/Store/Pages/ProductList/Handlers/SetFilterQuery";
import { ProductFilters } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";
import loadMorePLP from "@tSurya/Handlers/LoadMorePLP";
import CustomApplicationState from "@tSurya/Store/Data/CustomApplicationState/CustomApplicationState";

type HandlerType = HandlerWithResult<ProductFilters, ProductFilters>;


export const DispatchSetProductFiltersEmpty: HandlerType = props => {
     const state = props.getState() as CustomApplicationState;

    //  if(state.SURData.loadMore.loadMore){
    //     loadMorePLP({ loadMore: false });
    //      props.dispatch(setFilterQuery());
        
    // }
};

replaceInChain(chain,DispatchSetFilterQuery,DispatchSetProductFiltersEmpty);